import { ArrowLeft, ArrowRight } from "components/atoms/Icon";
import { Typography } from "components/atoms";
import "./index.scss";
import classNames from "classnames";

interface IProps {
  pages: any;
  currentPage: any;
  setCurrentPage: any;
  theme: "light" | "dark";
}

export const Pagination = ({
  pages,
  currentPage,
  setCurrentPage,
  theme,
}: IProps) => {
  const pagesArray = Array(Math.ceil(pages / 5))
    .fill(0)
    .map((_, i) => i + 1);

  const onBackClick = () => {
    if (currentPage !== 1) {
      setCurrentPage((prev: any) => prev - 1);
    }
  };

  const onNextClick = (pages: any) => {
    if (currentPage < pages) {
      setCurrentPage((prev: any) => prev + 1);
    }
  };

  const onPageClick = (page: any) => {
    setCurrentPage(page);
  };

  return (
    <div className="pagination-wrapper">
      <div className="back-wrapper" onClick={onBackClick}>
        <ArrowLeft color={theme === "light" ? "black" : "#329EE2"} />
        <Typography
          label="Back"
          variant="h7Med"
          styles="page-nav-text-custom-style"
        />
      </div>
      <div className="numbers-wrapper">
        {pagesArray.map((page: any, index: number) => (
          <div
            className={classNames({
              "page-wrapper": true,
              "is-active": currentPage === page,
            })}
            key={index}
            onClick={() => onPageClick(page)}
          >
            <Typography
              label={page}
              variant="h7Med"
              styles="page-number-custom-style"
            />
          </div>
        ))}
      </div>
      <div
        className="next-wrapper"
        onClick={() => onNextClick(pagesArray.length)}
      >
        <Typography
          label="Next"
          variant="h7Med"
          styles="page-nav-text-custom-style"
        />
        <ArrowRight color={theme === "light" ? "black" : "#329EE2"} />
      </div>
    </div>
  );
};
